module.exports = __webpack_public_path__ + "static/media/38.ad3850fd.jpg";